import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { TemplateSixteenSection } from "./common/sections";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSixteenSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && (enableHighlight || enableMistakeHighlight) ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        ) : summary ? (
          <ResumePDFText themeColor="black">{summary}</ResumePDFText>
        ) : null}
      </View>
    </TemplateSixteenSection>
  );
};
